import { Center, Checkbox, Skeleton } from '@chakra-ui/react';
import GenericDataTableBtn from '@Modules/core/components/table/GenericDataTableBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TCommonDataTable = {
  primaryKey: string | number,
  date: string,
  tc: string,
  referenceNumber: string,
  trader: string,
  cardNumber: string,
  amount: string,
  currencyCode: string,
  source: string,

  currency: string,
  dba: string,

  isChecked?: boolean,
};

type Props = {
  isLoading: boolean | undefined,
  hasCheckbox?: boolean | undefined,
  handleBtn: (row: any) => void,
};

const columnHelper = createColumnHelper<TCommonDataTable>();

export function getCommonDataTableColumns({
  isLoading,
  handleBtn,
  hasCheckbox,
}: Props) {
  const commonTab = [
    columnHelper.accessor('date', {
      id: 'date',
      header: 'Date',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('tc', {
      id: 'tc',
      header: 'TC',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('referenceNumber', {
      id: 'referenceNumber',
      header: 'Num. Réference',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('trader', {
      id: 'trader',
      header: 'Commerçant',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cardNumber', {
      id: 'cardNumber',
      header: 'Num. Carte',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('amount', {
      id: 'amount',
      header: 'Montant',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('currencyCode', {
      id: 'currencyCode',
      header: 'Devise',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('source', {
      id: 'source',
      header: 'Source',
      cell: '',
      enableHiding: false,
    }),

    columnHelper.accessor('currency', {
      id: 'currency',
      header: 'Monnaie',
      cell: '',
      enableHiding: false,
    }),

    columnHelper.accessor('dba', {
      id: 'dba',
      header: 'D/B/A',
      cell: '',
      enableHiding: false,
    }),
  ];

  const displayColumn = columnHelper.display({
    id: 'action',
    header: '',
    cell: (props) => {
      return (
        <Skeleton isLoaded={!isLoading}>
          <Center>
            <GenericDataTableBtn
              label="Transaction"
              onClick={() => handleBtn(props.row)}
            />
          </Center>
        </Skeleton>
      );
    },
  });

  if (!!hasCheckbox)
    return [
      ...commonTab,
      columnHelper.accessor('isChecked', {
        id: 'isChecked',
        header: '',
        cell: (props) => {
          return <Skeleton isLoaded={!isLoading}><Checkbox isChecked={!!props.getValue()}></Checkbox></Skeleton>;
        },
      }),
      displayColumn,
    ];
  else return [...commonTab, displayColumn];
}
